import { SubjectsState } from '../../types';
import * as types from './types';

export const setSelectedSubject = (payload: SubjectsState) => {
  return {
    type: types.SET_SELECTED_SUBJECT,
    payload,
  };
};

export const setAllSubjects = (payload: SubjectsState) => {
  return {
    type: types.SET_SELECTED_SUBJECT,
    payload,
  };
};
